var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0001 11.0041H18.5901L15.2901 7.71409C15.1018 7.52579 14.996 7.27039 14.996 7.00409C14.996 6.73779 15.1018 6.4824 15.2901 6.29409C15.4784 6.10579 15.7338 6 16.0001 6C16.2664 6 16.5218 6.10579 16.7101 6.29409L21.7101 11.2941C21.8011 11.3892 21.8725 11.5013 21.9201 11.6241C22.0201 11.8676 22.0201 12.1406 21.9201 12.3841C21.8725 12.5068 21.8011 12.619 21.7101 12.7141L16.7101 17.7141C16.6171 17.8078 16.5065 17.8822 16.3847 17.933C16.2628 17.9838 16.1321 18.0099 16.0001 18.0099C15.8681 18.0099 15.7374 17.9838 15.6155 17.933C15.4937 17.8822 15.3831 17.8078 15.2901 17.7141C15.1964 17.6211 15.122 17.5105 15.0712 17.3887C15.0204 17.2668 14.9943 17.1361 14.9943 17.0041C14.9943 16.8721 15.0204 16.7414 15.0712 16.6195C15.122 16.4977 15.1964 16.3871 15.2901 16.2941L18.5901 13.0041H3.0001C2.73489 13.0041 2.48053 12.8987 2.293 12.7112C2.10546 12.5237 2.0001 12.2693 2.0001 12.0041C2.0001 11.7389 2.10546 11.4845 2.293 11.297C2.48053 11.1094 2.73489 11.0041 3.0001 11.0041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.46bf37afaeff80f82fb466d411bcd24c.svg";
export { ForwardRef as ReactComponent };